exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2WDj_4eCdkGUAOTdZMWwla{border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverviewBadge": "_2WDj_4eCdkGUAOTdZMWwla"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/UserDashboard/AcademicInfo/AcademicInfoGroups/OverviewBadge/style.postcss
// module id = 2079
// module chunks = 0